import { render, staticRenderFns } from "./RepVotersByRegion.vue?vue&type=template&id=3d43c050"
import script from "./RepVotersByRegion.vue?vue&type=script&lang=js"
export * from "./RepVotersByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports